<app-page>
  <create-post-form></create-post-form>
</app-page>
